import * as React from 'react';

import classNames from 'classnames';

import s from './UniqueSellingPoints.module.scss';
import { Image as ImageType, renditions } from '../../types';
import Image from "../Image";
import { MediaQuery } from "../Image/Image";

export interface UniqueSellingPointsProps {
    title?: string;
    image: ImageType;
    items: Array<string>;
    align?: 'left' | 'right';
}


const UniqueSellingPoints: React.FC<UniqueSellingPointsProps> = ({ title, image, items = [], align }) => {
    const getMediaQueries = (renditions: renditions): MediaQuery[] => {
        let mediaQueries = [];
        mediaQueries = [
            ...mediaQueries,
            { minWidth: 960, src: renditions?.xl?.src },
            { minWidth: 768, src: renditions?.large?.src },
            { minWidth: 480, src: renditions?.medium?.src },
            { minWidth: 360, src: renditions?.small?.src },
        ];

        return mediaQueries.filter((x) => x.src);
    }

    return (
        <div className={classNames(s.Root, {
            [s["Root--Left"]]: align === 'left',
            [s["Root--Right"]]: align === 'right',
        })} >
            {!!image && (
                <Image
                    image={image}
                    containerClass={s.ImageContainer}
                    className={s.Image}
                    mediaQueries={getMediaQueries(image.renditions)}
                />
            )}
            <div className={s.TextWrapper}>
                <div className={s.Title}>
                    {title}
                </div>
                <ul className={s.Items}>
                    {items.map((item, index) => (
                        <li className={s.Item} key={index}>
                            {item}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default UniqueSellingPoints;
